import { ReactNode } from 'react';

import { Icon } from '@personly/libs-widgets';

interface Props {
  children: ReactNode;
  icon: any;
  legend: any;
  orientation: any;
}

const TableHeader = ({ children, icon, legend, orientation }: Props) => {
  const classNames = [
    'flex',
    'flex-row',
    'flex-1',
    'place-items-center',
    'items-center',
    'font-bold',
  ];

  if (legend || (!legend && orientation === 'column'))
    classNames.push('!text-record-header-color');

  if (orientation === 'row') classNames.push('justify-center');

  return (
    <div className={classNames.join(' ')}>
      <div className="flex">
        {icon && (
          <span className={'flex items-center pr-2'}>
            <Icon icon={icon} type={'solid'} size="lg" />
          </span>
        )}
        {children}
      </div>
    </div>
  );
};

export default TableHeader;
